export default __webpack_public_path__ + "static/media/white.4a5a6327.png";